import { render, staticRenderFns } from "./MediaImage.vue?vue&type=template&id=4a20cfa0&"
import script from "./MediaImage.vue?vue&type=script&lang=js&"
export * from "./MediaImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports